import React, { useContext } from "react";
import MemberDetails from "../../components/MemberDetails";
import { UserContext } from "../../context/Context";

const MemberProfile = () => {
  const { user } = useContext(UserContext);

  return (
    <div>
      <MemberDetails member={user} />
    </div>
  );
};

export default MemberProfile;
